import React from "react";
import useStyles from "./styles";

import { Grid, Button } from "@material-ui/core";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";

const ErrorPage = () => {
	const classes = useStyles();
	const history = useHistory();

	const handleGoBack = () => {
		history.goBack();
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<img
				src={Images.logoError}
				alt={"logoError"}
				width={255}
				height={200}
			/>
			<Grid classes={{ root: classes.title }}>
				Xin lỗi, trang bạn đã truy cập không tồn tại
			</Grid>
			<Button
				classes={{ root: classes.btnSubmit }}
				onClick={() => handleGoBack()}
			>
				Quay lại
			</Button>
		</Grid>
	);
};

export default ErrorPage;
